import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function ViewSelector(props: Props) {
  const { t } = useTranslation();

  return (
    <SelectList
      rootClassName={styles.viewSelector}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p>{t(`secondaryCriteriaTemplate.views.${props.view}`)}</p>
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {[
              "projectElement",
              "project",
              "resource",
              "projectReport",
              ...(props.scope === "planzone" ? ["timeRecord"] : []),
            ].map((view) => (
              <div
                key={view}
                className={classNames(styles.item, {
                  [styles.selected]: view === props.view,
                })}
                onClick={() => select(props.select(view as any))}
              >
                <p>{t(`secondaryCriteriaTemplate.views.${view}`)}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ViewSelector };
